import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconPlay from 'components/icons/IconPlay';
import useVideoMetadata from 'hooks/useVideoMetadata';
import PDPDesktopHeroThumbnail from '../PDPDesktopHeroThumbnail';

const PDPDesktopStudioThumbnails = ({
  enableCrops,
  loading = false,
  openModal,
  pdpIsModularBYOProduct = false,
  photos = [],
  selectedPhoto = null,
  setSelectedPhoto,
  setIsVideoSelected = () => {},
  introVideoId,
  mode = 'pdp',
  isVideoSelected,
  viewGalleryImageEvent,
}) => {
  const { thumbnail: videoThumbnailUrl } = useVideoMetadata({
    videoId: introVideoId,
  });
  if (loading) {
    return (
      <div
        className={classNames('flex', {
          'max-[1023px]:md:justify-center': mode === 'quickview',
        })}
      >
        {[0, 1, 2, 3, 4].map((val, idx) => (
          <PDPDesktopHeroThumbnail
            key={`PDPDesktopHeroThumbnail${idx}`} // eslint-disable-line react/no-array-index-key
            loading
          />
        ))}
      </div>
    );
  }

  if (!photos.length) {
    return null;
  }

  const displayCount = introVideoId ? 4 : 5;
  const firstFivePhotos = photos.slice(0, displayCount);
  const lastIndex = displayCount - 1;

  return (
    <div
      className={classNames('flex', {
        'max-[1023px]:md:justify-center': mode === 'quickview',
      })}
    >
      {firstFivePhotos.map(({ id, src, cropData }, index) => {
        if (photos.length > 5 && index === lastIndex) {
          if (mode === 'quickview') {
            return null;
          }

          return (
            <PDPDesktopHeroThumbnail
              enableCrops={enableCrops}
              key={`PDPDesktopHeroThumbnails${id}`}
              onClick={() => {
                setSelectedPhoto?.({ type: 'studio', index: 0 });
                openModal(id);
              }}
            >
              {`+${photos.length - lastIndex}`}
            </PDPDesktopHeroThumbnail>
          );
        }

        return (
          <React.Fragment key={`PDPDesktopHeroThumbnails${id}`}>
            {!!introVideoId && index === 1 && (
              <PDPDesktopHeroThumbnail
                cropData={cropData}
                enableCrops={enableCrops}
                key={-1}
                src={videoThumbnailUrl}
                isSelected={isVideoSelected}
                onClick={setIsVideoSelected}
                iconCenter
                icon={<IconPlay width={24} height={24} />}
              />
            )}
            <PDPDesktopHeroThumbnail
              cropData={cropData}
              enableCrops={enableCrops}
              key={id}
              src={src}
              isSelected={
                pdpIsModularBYOProduct
                  ? selectedPhoto === id
                  : selectedPhoto === src
              }
              onClick={() => {
                setSelectedPhoto?.({ type: 'studio', id, index, src });
              }}
              onMouseEnter={() => {
                setSelectedPhoto?.({ type: 'studio', id, index, src });
                viewGalleryImageEvent({
                  imageLocation: 'Hero Gallery',
                  imageFilename: src?.split('/').pop() || '',
                  position: index,
                  totalImages: photos.length,
                });
              }}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
};

PDPDesktopStudioThumbnails.propTypes = {
  enableCrops: PropTypes.bool,
  introVideoId: PropTypes.string,
  isVideoSelected: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  openModal: PropTypes.func,
  pdpIsModularBYOProduct: PropTypes.bool,
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
    })
  ),
  selectedPhoto: PropTypes.string,
  setSelectedPhoto: PropTypes.func,
  setIsVideoSelected: PropTypes.func,
  viewGalleryImageEvent: PropTypes.func,
};

export default PDPDesktopStudioThumbnails;
